function initCeSlider(){
    // random order option
    $.fn.randomize = function(selector){
        var $elems = selector ? $(this).find(selector) : $(this).children(),
            $parents = $elems.parent();

        $parents.each(function(){
            $(this).children(selector).sort(function(){
                return Math.round(Math.random()) - 0.5;
            }).detach().appendTo(this);
        });

        return this;
    };

    // randomize the slides and then call slick
    $('.frame-type-mask_ce_img_slider').find('.slider-random-order').randomize('.slide');

    $('.frame-type-mask_ce_img_slider .slider').slick(
        {
            arrows:false,
            dots:false,
            autoplay:true,
            pauseOnHover:false,
            fade:true,
            speed: 1000,
            //adaptiveHeight: true,
            autoplaySpeed: 3000,
        }
    );

    // grid element slider
    $('.grid-slider .slider').slick(
        {
            arrows:true,
            dots:true,
            autoplay:false,
            pauseOnHover:false,
            fade:true,
            speed: 1000,
            //adaptiveHeight: true,
            autoplaySpeed: 3000,
        }
    );

    // container slider
    $('.frame-container-type-container-slider .slider').each(function() {
        let _slidesToShow = $(this).data("slides-to-show");
        let _slidesToScroll = $(this).data("slides-to-scroll");
        let _infinite = $(this).data("infinite") === 1;
        $(this).slick(
            {
                arrows:true,
                dots:true,
                autoplay:false,
                pauseOnHover:false,
                speed: 600,
                slidesToShow: _slidesToShow,
                slidesToScroll: _slidesToScroll,
                infinite: _infinite,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            speed: 300,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 300,
                            dots: true
                        }
                    }
                ]
            }
        );
    });

    /*$('.frame-container-type-container-slider .slider').slick(
        {
            arrows:true,
            dots:true,
            autoplay:false,
            pauseOnHover:false,
            //fade:true,
            speed: 1000,
            //adaptiveHeight: true,
            //autoplaySpeed: 3000,
            slidesToShow: $(this).data("slides-to-show"),
            slidesToScroll: $(this).data("slides-to-scroll"),
        }
    );*/

    // quotes slider
    $('.quote-slider').slick(
        {
            arrows: false,
            dots: true,
            autoplay: true,
            pauseOnHover: false,
            fade: false,
            swipe: true,
            speed: 3000,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        dots: false,
                        centerMode: true,
                        fade: false,
                        centerPadding: '38px',
                        adaptiveHeight: false
                    }
                }
            ],
        }

    );


}